<template>
  <div>
    <vs-popup classContent="popup-example" title="Crear origen de datos" :active.sync="active">
      <vs-input class="inputx mb-3 w-full" :placeholder="$t(`DATASOURCEVIEW.description`)" v-model.trim="descripcion" />
      <vs-button :disabled="!disabled" color="primary" type="filled" class="w-full" @click="_create(descripcion)">{{$t(`DATASOURCEVIEW.Create`)}}</vs-button>
    </vs-popup>
  </div>
</template>

<script>
import {  mapActions } from "pinia";
import { useConnStore } from "./store";
import { notify, loading, closeLoding } from "@/helpers/$vs.js";
export default {
  props: ["popupActive"],
  data: () => ({
    descripcion: ""
  }),
  computed: {
    active: {
      get() {
        return this.popupActive;
      },
      set(value) {
        this.$emit("popupActive", value);
      }
    },
    disabled() {
      return this.descripcion.trim().length > 3;
    }
  },
  methods: {
      ...mapActions(useConnStore, ["createOrigen"]),
      async _create(descripcion) {
          loading()
          const result = await this.createOrigen(descripcion);
          if(!result) return notify(this.$t(`DATASOURCEVIEW.originData`), this.$t(`DATASOURCEVIEW.errorToCreateOrigin`), `danger`); 
          notify(this.$t(`DATASOURCEVIEW.originData`), this.$t(`DATASOURCEVIEW.successCreate`), `success`); 
          this.active = false;
          closeLoding()

      }
  }
};
</script>

<style lang="scss" scoped></style>
